/**
 * In-memory LRU cache of converted ThreadMessageLike[] history per
 * conversation. Lets the persistence hook seed the thread instantly on
 * a re-visit instead of waiting for /connect to round-trip.
 *
 * Cap is intentionally small — this is a UX optimization, not a
 * canonical store.
 */
import type { ThreadMessageLike } from "@assistant-ui/react";

interface HistoryCacheEntry {
  messages: ThreadMessageLike[];
}

const historyCache = new Map<string, HistoryCacheEntry>();
const MAX_CACHED = 10;

export function getCachedHistory(conversationId: string): ThreadMessageLike[] | null {
  return historyCache.get(conversationId)?.messages ?? null;
}

export function setCachedHistory(conversationId: string, messages: ThreadMessageLike[]): void {
  historyCache.set(conversationId, { messages });
  if (historyCache.size > MAX_CACHED) {
    // Map iteration order is insertion order — first key is oldest
    const oldest = historyCache.keys().next().value;
    if (oldest != null) historyCache.delete(oldest);
  }
}
